// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Vetting20 from './Vetting20.tsx';
import Vetting20Filled from './Vetting20Filled.tsx';
import Vetting24 from './Vetting24.tsx';
import Vetting24Filled from './Vetting24Filled.tsx';
import Vetting40 from './Vetting40.tsx';
import Vetting40Filled from './Vetting40Filled.tsx';
import Vetting48 from './Vetting48.tsx';
import Vetting48Filled from './Vetting48Filled.tsx';

type VettingProps = {
    variation: '20' | '20Filled' | '24' | '24Filled' | '40' | '40Filled' | '48' | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Vetting20,
    Vetting20Filled,
    Vetting24,
    Vetting24Filled,
    Vetting40,
    Vetting40Filled,
    Vetting48,
    Vetting48Filled,
};

const Vetting: FC<VettingProps> = ({ variation, ...props }) => {
    const variationKey = `Vetting${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Vetting" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Vetting;
